import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAlbum } from '../../../commons/customHooks/Album';
import { useBanner } from '../../../commons/customHooks/Banner';
import { useVideoRender } from '../../../commons/customHooks/Video';
import VideoMessageMakerComponent from '../components/messageMaker';
import * as videoAction from '../redux/actions';
const CATEGORIES = [
  {label: "카드사진", value: "image_card", contentType: "image"},
  {label: "캐릭터사진", value: "character_selfie", contentType: "image"},
  {label: "나의 영상편지", value: "video_message", contentType: "video"},
]

const VideoMessageMakerContainer = () => {

  const [category, setCategory] = useState(CATEGORIES[2]);
  const [params, setParams] = useState({type: category.value, limit: 50})
  const [albums, isProcessing] = useAlbum(params);
  const [param, ] = useState({
    relation: ['characterPose', 'videoMessageTemplete']
  })
  const [videoRender, isProcessingVideoRender] = useVideoRender(param);
  const {userInfo} = useSelector((state) => state.authReducers);
  const {coupon} = useSelector((state) => state.giftboxReducers);
  const {isProcessingDel} = useSelector((state) => state.videoDetailReducers);
  const [bannerParams] = useState({
    type: 'app_video_maker'
  })
  const [ banners ] = useBanner(bannerParams);

  return <VideoMessageMakerComponent
    banners={banners}
    albums={albums}
    isProcessing={isProcessing}
    userInfo={userInfo}
    videoPaymentClearState={videoAction.videoPaymentClearState}
    coupon={coupon}
    updateExplainVideoPopup={videoAction.updateExplainVideoPopupRequest}
    getTimeVideoRenderRequest={videoAction.getTimeVideoRenderRequest}
    videoRender={videoRender}
    isProcessingVideoRender={isProcessingVideoRender}
    isProcessingDel={isProcessingDel}
  />;
};

export default VideoMessageMakerContainer;
